module.exports = __webpack_public_path__ + "static/media/especie.6cf56874.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/central_fert/especie.png
// module id = 2908
// module chunks = 3